import { useState } from 'react';
import ImageContainer from './ImageContainer/ImageContainer';
import { resolveAssetUrl } from '../utils/resolveAssetUrl';

const BrandLogo = ({
  src = '',
  alt = 'Homevilas',
  size = 40,
  className = '',
  imgClassName = '',
  fallback = 'HV',
  fallbackClassName = 'text-slate-900 font-semibold',
}) => {
  const [failed, setFailed] = useState(false);
  const logoUrl = resolveAssetUrl(src);
  const dimension = typeof size === 'number' ? `${size}px` : size;
  const showImage = logoUrl && !failed;

  return (
    <div
      className={`flex items-center justify-center overflow-hidden ${className}`}
      style={{ width: dimension, height: dimension }}
    >
      {showImage ? (
        <ImageContainer
          src={logoUrl}
          alt={alt}
          ratio="1/1"
          radius={0}
          fit="contain"
          hoverZoom={false}
          onError={() => setFailed(true)}
          className="h-full w-full"
          imgClassName={imgClassName}
        />
      ) : (
        <span className={fallbackClassName}>{fallback}</span>
      )}
    </div>
  );
};

export default BrandLogo;
